import { Link, NavLink, useLocation } from 'react-router';
import { Logo } from '@/components/common/Logo';
import { MobileMenu } from '@/components/layout/MobileMenu';
import { Button } from '@/components/ui/button';
import { Brand } from '@/constants/brand';
import { GetStartedLink, PrimaryNavigation } from '@/constants/navigation';
import { Routes } from '@/constants/routes';
import { cn } from '@/lib/utils';

function getDesktopLinkClassName({ isActive }) {
  return cn(
    'relative rounded-md px-3 py-2 text-[0.9375rem] font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-graphite',
    isActive
      ? 'text-graphite after:absolute after:inset-x-3 after:bottom-0.5 after:h-0.5 after:rounded-full after:bg-redline'
      : 'text-steel hover:text-graphite'
  );
}

export function Header() {
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 border-b border-grid bg-paper">
      <div className="section-container flex h-16 items-center justify-between gap-6">
        <Link
          to={Routes.home}
          aria-label={`${Brand.name} home`}
          className="rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-graphite"
        >
          <Logo />
        </Link>
        <nav aria-label="Main" className="hidden items-center gap-1 lg:flex">
          {PrimaryNavigation.map((navigationLink) => (
            <NavLink key={navigationLink.to} to={navigationLink.to} end className={getDesktopLinkClassName}>
              {navigationLink.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Button asChild size="sm" className="hidden sm:inline-flex">
            <Link to={GetStartedLink.to}>{GetStartedLink.label}</Link>
          </Button>
          <MobileMenu key={location.key} />
        </div>
      </div>
    </header>
  );
}